import { CBadge, CCol, CContainer, CRow } from "@coreui/react";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./QuizComponent.css";

function MultipleSelectSuperadmin({
  type,
  num,
  question,
  score,
  data,
  onAnswerChange,
  questionID,
  questionTypeID,
}) {
  const [selectedOptions, setSelectedOptions] = useState("");

  const handleSelectOption = (optionId) => {
    if (selectedOptions.split(",").includes(optionId.toString())) {
      const updatedOptions = selectedOptions
        .split(",")
        .filter((id) => id !== optionId.toString())
        .join(",");
      setSelectedOptions(updatedOptions);
    } else {
      setSelectedOptions(
        selectedOptions ? `${selectedOptions},${optionId}` : optionId.toString()
      );
    }
  };

  useEffect(() => {
    if (selectedOptions) {
      onAnswerChange(questionID, questionTypeID, selectedOptions);
    }
  }, [selectedOptions]);

  const getStyle = (ans) => {
    if (ans.value === 1) {
      return {
        backgroundColor: "#28a745", // Green background
        color: "white", // White text
      };
    }
    return {}; // Default empty style
  };

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
              <Typography
                variant="question"
                component="div"
                gutterBottom
                sx={{ color: "primary.main", mb: 2 }}
              >
                {`Q${num + 1}. ${question}`}
              </Typography>
              <ul>
                <CRow xs={{ gutterY: 2 }}>
                  <CCol xs={12}>
                    <CRow xs={{ gutterY: 2 }}>
                      {data.map((ans) => (
                        <CCol xs={12} key={ans.answerId}>
                          <div
                            className="d-flex align-items-start"
                            style={{ paddingRight: "20px" }}
                          >
                            <input
                              disabled={type === "3" ? false : true}
                              className="form-check-input options"
                              type="checkbox"
                              id={ans.answerId}
                              name={ans.answerId}
                              value={ans.value}
                              onChange={() => handleSelectOption(ans.answerId)}
                              checked={selectedOptions.includes(ans.answerId)}
                              style={{
                                ...getStyle(ans),
                                marginTop: "6px",
                              }}
                            />
                            <label
                              className="optionText"
                              style={{
                                marginLeft: "12px",
                                flex: 1,
                                lineHeight: "1.5",
                              }}
                              htmlFor={ans.answerId}
                            >
                              {ans.label}
                            </label>
                          </div>
                        </CCol>
                      ))}
                    </CRow>
                  </CCol>
                </CRow>
              </ul>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default MultipleSelectSuperadmin;
